import MainBannerWrapper from './MainBannerWrapper';

export default MainBannerWrapper;
